<template>
  <l-marker v-if="latLngPosition"
            :lat-lng="latLngPosition"
            :icon="markerIcon"
            @mouseover="enableMouseover ? $emit('mouseover', position) : null"
            @mouseout="enableMouseover ? $emit('mouseout', position) : null"
  >
    <l-popup v-if="popup" :content="popupText" />
  </l-marker>
</template>

<script>
import { each } from 'lodash-es'
import L from 'leaflet'
import { LMarker, LPopup } from 'vue2-leaflet'

import 'leaflet/dist/leaflet.css'
import 'drmonty-leaflet-awesome-markers/css/leaflet.awesome-markers.css'
import 'drmonty-leaflet-awesome-markers'

export default {
  components: { LMarker, LPopup },

  props: {
    // Position object that will be displayed on map
    position: {
      type: Object,
      required: true,
      default: () => []
    },
    // Function to create latLng object to position the marker
    // Default uses latitude and longitude attributes
    createLatLng: {
      type: Function,
      default: position => L.latLng(position.latitude, position.longitude)
    },
    // Display popup on click?
    popup: {
      type: Boolean,
      default: false
    },
    // Popup content, use $0, $1...$n to display data attribute
    popupContent: {
      type: String,
      default: ''
    },
    // Array of data attributes to display in popupContent
    popupData: {
      type: Array,
      default: () => []
    },
    // Font awesome icons
    icon: {
      type: String,
      required: true
    },
    iconPrefix: {
      type: String,
      default: 'icon'
    },
    iconColor: {
      type: String,
      default: 'white'
    },
    markerColor: {
      type: String,
      default: 'black'
    },

    // Enable or disable event handler
    // Default to false to not sent unusefull events
    enableMouseover: { type: Boolean, default: false }
  },

  computed: {
    latLngPosition () {
      return this.createLatLng(this.position)
    },

    markerIcon () {
      return new L.AwesomeMarkers.Icon({
        icon: this.icon,
        prefix: this.iconPrefix,
        markerColor: this.markerColor,
        iconColor: this.iconColor
      })
    },

    popupText () {
      if (!this.popup) return ''
      if (!this.popupData) return this.popupContent

      let parsedContent = this.popupContent

      each(this.popupData, (attr, index) => {
        if (typeof attr === 'object') {
          // Passing an object attr/[index]/formatter to format data
          let attrValue = this.position[attr.attr]

          // In case of an array, pass index number to get the correct value
          if (attr.index !== undefined) {
            attrValue = attrValue[attr.index]
          }

          // In case we need to format data, pass a formatter function
          if (attr.formatter) {
            attrValue = attr.formatter(attrValue)
          }

          // Then replace it in popup
          parsedContent = this.$utils.replaceAll(parsedContent, '$' + index, attrValue)
        } else {
          // Passing only a string attr to get raw data
          parsedContent = this.$utils.replaceAll(parsedContent, '$' + index, this.position[attr])
        }
      })

      return parsedContent
    }
  }
}
</script>
